import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaReplacement'
})
export class CommaReplacementPipePipe implements PipeTransform {

  transform(value: number | string) {
    return value.toString().replace('.', ',');
  }
}
